export default __webpack_public_path__ + "static/media/sitedetail.41462bbb.png";